import { CampaignTypes, DashboardTypes } from 'features/Codes'
import { oppositeSortOrder } from 'utils'
import {
  CheckboxSpecs,
  FilterMenus,
  FilterOperators,
  FilterTypes,
} from 'features/dashboard/filter/FilterSpecs'

import { ColumnSorts, MetricColumns } from '../../Columns'
import { isNil } from 'lodash'

export const sortToParam = ({ name, order }) => {
  const { reversed = false } = ColumnSorts[name]
  return `${name} ${reversed ? oppositeSortOrder(order) : order}`
}
export const filterMetricColumns = columns =>
  columns.filter(column => MetricColumns[column])
export const isReportSort = name => name in MetricColumns
export const getDomainKey = type =>
  type === DashboardTypes.CREATIVE ? 'creativeLinkId' : 'id'

const FilterDomains = {
  campaign: 'campaignFilters',
  adGroup: 'adGroupFilters',
  keyword: 'keywordFilters',
  creativeLink: 'creativeFilters',
}

export const filterToParam = (filters = []) => {
  const domainFilters = {
    campaignFilters: [],
    adGroupFilters: [],
    keywordFilters: [],
    creativeFilters: [],
    metrics: [],
  }
  filters.forEach(({ domain, key, data }, index) => {
    const isMetrics = key in MetricColumns
    if (isMetrics) {
      domainFilters.metrics.push({
        domain,
        dimension: key,
        operator: data.operator,
        value: Number(data.value),
        order: index,
      })
    } else {
      const { filterType } = FilterMenus[domain].subs.find(
        sub => sub.key === key
      )
      const type =
        filterType === FilterTypes.MULTI
          ? 'multi'
          : key === 'operation'
          ? 'operation'
          : 'single'
      const result = {
        type,
        order: index,
      }
      if (type === 'operation') {
        result.statuses = data.values
      } else if (type === 'multi') {
        const checkboxDimension = CheckboxSpecs[key].dimension
        if (data.value === '') {
          result.type = 'single'
          result.dimension = checkboxDimension
          result.operator = 'eq'
          result.values = [
            key === 'maxBiddingAmount'
              ? 'INHERIT_FROM_ADGROUP'
              : data.checked
              ? 'N'
              : 'Y',
          ]
        } else {
          if (key === 'maxBiddingAmount') {
            const keywordMaxBiddingAmountFilters = [
              {
                type: 'single',
                dimension: key,
                operator: data.operator,
                values: [data.value],
                order: 0,
              },
            ]
            if (data.checked) {
              result.booleanOperator = 'or'
              keywordMaxBiddingAmountFilters.push({
                type: 'single',
                dimension: checkboxDimension,
                operator: 'eq',
                values: ['INHERIT_FROM_ADGROUP'],
                order: 1,
              })
            }
            result.filters = keywordMaxBiddingAmountFilters
          } else {
            result.booleanOperator = data.checked ? 'or' : 'and'
            result.filters = [
              {
                type: 'single',
                dimension: key,
                operator: data.operator,
                values: [data.value],
                order: 0,
              },
              {
                type: 'single',
                dimension: checkboxDimension,
                operator: 'eq',
                values: [data.checked ? 'N' : 'Y'],
                order: 1,
              },
            ]
          }
        }
      } else {
        result.dimension = key
        result.operator =
          filterType === FilterTypes.ID || filterType === FilterTypes.CHECKBOX
            ? FilterOperators.in.key
            : data.operator
        result.values =
          key === 'placementCategories' &&
          data.values.includes('PREMIUM_LINK_SEARCH_KAKAO')
            ? [...data.values, 'TALK_CHANNEL_SEARCH_KAKAO_TALK']
            : filterType === FilterTypes.ID
            ? data.value.split(',')
            : filterType === FilterTypes.CHECKBOX
            ? data.values
            : [data.value]
      }
      domainFilters[FilterDomains[domain]].push(result)
    }
  })
  return {
    ...(domainFilters.campaignFilters.length > 0 && {
      campaignFilters: {
        type: 'multi',
        booleanOperator: 'and',
        filters: domainFilters.campaignFilters,
      },
    }),
    ...(domainFilters.adGroupFilters.length > 0 && {
      adGroupFilters: {
        type: 'multi',
        booleanOperator: 'and',
        filters: domainFilters.adGroupFilters,
      },
    }),
    ...(domainFilters.keywordFilters.length > 0 && {
      keywordFilters: {
        type: 'multi',
        booleanOperator: 'and',
        filters: domainFilters.keywordFilters,
      },
    }),
    ...(domainFilters.creativeFilters.length > 0 && {
      creativeFilters: {
        type: 'multi',
        booleanOperator: 'and',
        filters: domainFilters.creativeFilters,
      },
    }),
    ...(domainFilters.metrics.length > 0 && {
      metrics: domainFilters.metrics,
    }),
  }
}

const convertDomainFilter = (filters, domain, accumulator) => {
  filters.forEach(filter => {
    const { type, order } = filter
    if (type === 'operation') {
      accumulator[order] = {
        domain,
        key: 'operation',
        data: {
          values: filter.statuses,
        },
      }
    } else if (type === 'multi') {
      const { dimension, operator, values } = filter.filters.find(
        item => item.order === 0
      )
      const [value] = values
      const checkbox = filter.filters.find(item => item.order === 1)
      const checked = checkbox ? checkbox.values[0] === 'N' : false
      accumulator[order] = {
        domain,
        key: dimension,
        data: {
          value,
          operator,
          checked,
        },
      }
    } else {
      const { dimension } = filter
      const checkboxDimensionKeys = Object.values(CheckboxSpecs).reduce(
        (acc, cur) => {
          acc[cur.dimension] = cur.key
          return acc
        },
        {}
      )
      if (dimension in checkboxDimensionKeys) {
        accumulator[order] = {
          domain,
          key: checkboxDimensionKeys[dimension],
          data: {
            value: '',
            operator: FilterOperators.like.key,
            checked: true,
          },
        }
      } else {
        const { filterType } = FilterMenus[domain].subs.find(
          sub => sub.key === dimension
        )
        accumulator[order] = {
          domain,
          key: dimension,
          data: {
            ...((filterType === FilterTypes.TEXT ||
              filterType === FilterTypes.NUMBER) && {
              value: filter.values[0],
              operator: filter.operator,
            }),
            ...(filterType === FilterTypes.CHECKBOX && {
              values: filter.values.filter(
                value => value !== 'TALK_CHANNEL_SEARCH_KAKAO_TALK'
              ),
            }),
            ...(filterType === FilterTypes.ID && {
              value: filter.values.join(','),
            }),
          },
        }
      }
    }
  })
}
const convertMetricFilter = (metrics, accumulator) => {
  metrics.forEach(({ domain, dimension, operator, value, order }) => {
    accumulator[order] = {
      domain,
      key: dimension,
      data: {
        value: String(value),
        operator,
      },
    }
  })
}
export const paramToFilter = (param = {}) => {
  const filters = new Array(30)
  ;['campaign', 'adGroup', 'keyword', 'creativeLink'].forEach(domain => {
    convertDomainFilter(
      param[FilterDomains[domain]]?.filters || [],
      domain,
      filters
    )
  })
  convertMetricFilter(param?.metrics || [], filters)
  return filters.filter(Boolean)
}
const { REACT_APP_DEPLOY_PHASE } = process.env

export const getPhaseToParam = () => {
  if (REACT_APP_DEPLOY_PHASE === 'production') {
    return 'PROD'
  } else if (REACT_APP_DEPLOY_PHASE === 'cbt') {
    return 'CBT'
  } else if (REACT_APP_DEPLOY_PHASE === 'dev') {
    return 'DEV'
  } else {
    return 'SANDBOX'
  }
}

const CampaignTypeKeys = {
  [DashboardTypes.CAMPAIGN]: 'type',
  [DashboardTypes.AD_GROUP]: 'adGroupType',
  [DashboardTypes.KEYWORD]: 'keywordType',
  [DashboardTypes.CREATIVE]: 'creativeType',
}
export const getCampaignType = (original, type) => {
  const key = CampaignTypeKeys[type]
  if (isNil(key)) {
    return CampaignTypes.PREMIUM_LINK
  }
  const value = original[key]
  return value === CampaignTypes.TALK_CHANNEL
    ? CampaignTypes.TALK_CHANNEL
    : CampaignTypes.PREMIUM_LINK
}

const talkChannelMetric = [
  MetricColumns.costPerImp.name,
  MetricColumns.convKfPfAdd7d.name,
  MetricColumns.costPerConvKfPfAdd7d.name,
  MetricColumns.convKfPfAdd7dRate.name,
  MetricColumns.convKfPfAdd1d.name,
  MetricColumns.costPerConvKfPfAdd1d.name,
  MetricColumns.convKfPfAdd1dRate.name,
]
export const isSupportedMetric = (campaignType, metricId) =>
  campaignType === CampaignTypes.PREMIUM_LINK
    ? !talkChannelMetric.includes(metricId)
    : metricId !== 'rank'

export const RateTypes = [
  MetricColumns.ctr.name,
  MetricColumns.convKfPfAdd7dRate.name,
  MetricColumns.convKfPfAdd1dRate.name,
]
